/* 孫吳傳・第 18 章：夷陵（黃武元年，222）
 * 史實：《三國志·陸遜傳》劉備連營而來，陸遜堅守不戰，諸將都想迎擊；後來蜀軍兵疲意沮，陸遜「乃敕各持一把茅，以火攻拔之。
 *       一爾勢成，通率諸軍同時俱攻」，連破四十餘營。劉備夜遁，退回白帝城。
 * 流程：1. 忍：蜀軍在營前挑釁，諸將按捺不住會擅自出擊；走到他身邊就能把他拉回來。有人衝到蜀營、或陸遜自己越過界線，軍心就掉；掉光戰敗。
 *       2. 時機到了：每人持一把茅，站在蜀營旁點火（讀條），火順著西風沿連營燒過去。八座營都燒起來，劉備夜遁即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, hero, PEOPLE, TROOPS, rout, vanish } from '../kit.ts';
import { CAMPS, WU, LIUBEI, HOLD_X } from '../maps/yiling.ts';

const LV = 15, WAIT = 80;
const TAUNT = ['吳狗！出來一戰！', '陸遜小兒，只會躲在營裡嗎？', '江東無人了嗎？', '書生也敢領兵？'];

export default {
  id: 'sunwu-18', map: 'yiling', hero: 'luxun',
  title: '第 16 章　夷陵', year: '黃武元年（222）',
  brief: {
    quote: [{ text: '乃敕各持一把茅，以火攻拔之。', src: '《三國志·吳書·陸遜傳》' }],
    text: '劉備為關羽報仇，親率大軍東下，從巫峽到夷陵連營數百里。陸遜堅守不戰，諸將或是孫策時的舊將、或是宗室貴戚，都不服這個書生。',
    goals: ['忍：拉回擅自出擊的將領，不要越過界線', '時機到了，火燒連營'],
  },
  words: { ally: '吳兵', foe: '蜀軍' },
  fuel(m, x, y) { return CAMPS.some(([cx, cy]) => SG.gd(x, y, cx, cy) < 420) || (Math.abs(y - 2050) < 260 && x > 1700 && x < 7900 && !SG.MAP.waterAt(x, y)); },
  spreadMul() { return 1.3; },
  stars: [
    { text: '軍心保住七成以上', ok: (m) => m.vars.moraleMin >= 70 },
    { text: '沒有一個將領衝到蜀營', ok: (m) => !m.vars.reached },
    { text: '下令火攻後 60 秒內八營皆燃', ok: (m) => m.vars.burnT != null && m.vars.burnT <= 60 },
  ],
  steps: [
    { // 1. 忍
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = WU[0] - 300; me.y = WU[1];
        V.morale = 100; V.moraleMin = 100; V.t0 = w.t;
        V.gens = [['handang', PEOPLE.handang, '韓當'], ['xusheng', 'xusheng', '徐盛'], ['zhuran', PEOPLE.zhuran, '朱然']].map(([k, spec, name], i) => {
          const u = ally(w, spec, WU[0] - 200 + i * 120, WU[1] - 180 + i * 150, LV - 1); u.name = name; u.hold = [u.x, u.y]; u.post = u.hold.slice(); return u;
        });
        V.men = Array.from({ length: 8 }, (_, i) => { const u = m.recruit(WU[0] - 100 - (i % 4) * 60, WU[1] + 200 + Math.floor(i / 4) * 70, '吳兵'); u.home = [u.x, u.y]; return u; });
        // 營前挑釁的蜀兵
        V.taunt = Array.from({ length: 6 }, (_, i) => { const u = m.foe('huangjin', HOLD_X - 600 - (i % 3) * 90, 1900 + Math.floor(i / 3) * 220, { spec: TROOPS.shu, name: '蜀兵' }); u.home = [u.x, u.y]; return u; });
        V.shu = [];
        CAMPS.forEach(([x, y]) => { for (let i = 0; i < 3; i++) { const u = m.foe('huangjin', x + (i - 1) * 90, y + 120, { spec: TROOPS.shu, name: '蜀兵' }); u.home = [u.x, u.y]; V.shu.push(u); } });
        V.lb = boss(w, hero('liubei'), LIUBEI[0], LIUBEI[1], { name: '劉備', untargetable: true, hp: 9999 });
        V.nextHot = 8;
        m.card('諸將並欲迎擊備，遜以爲不可。', '《陸遜傳》');
        m.line('陸遜', '劉備舉軍東下，銳氣始盛。且堅守，待其疲弊。');
        m.after(5, () => m.line('提示', '將領會按捺不住擅自出擊：走到他身邊就能拉回來。不要越過營前的界線。'));
        m.obj('wait', '');
        m.obj('morale', '');
        m.mark('line', HOLD_X, WU[1] - 300, '界線', true);
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        const left = WAIT - (w.t - V.t0);
        m.get('wait').text = `忍：等蜀軍疲憊（還要 ${Math.max(0, Math.ceil(left))} 秒）`;
        // 挑釁
        V.tauntT = (V.tauntT || 3) - dt;
        if (V.tauntT <= 0) { V.tauntT = 6 + SG.rand() * 4; m.line('蜀兵', TAUNT[Math.floor(SG.rand() * TAUNT.length)]); }
        // 擅自出擊：每 14～20 秒有一個將領衝出去
        V.nextHot -= dt;
        if (V.nextHot <= 0) {
          V.nextHot = 14 + SG.rand() * 6;
          const g = V.gens.filter((u) => u.alive && !u.hot)[Math.floor(SG.rand() * 3)];
          if (g) { g.hot = true; g.hold = [CAMPS[0][0], CAMPS[0][1]]; m.line(g.name, ['老將受不了這口氣！出擊！', '書生懂什麼打仗！我去也！', '末將去取劉備首級！'][V.gens.indexOf(g)]); m.mark('hot' + g.id, g.x, g.y, '擅自出擊', false, g); }
        }
        for (const g of V.gens) {
          if (!g.hot || !g.alive) continue;
          if (SG.gd(g.x, g.y, me.x, me.y) < 170) { g.hot = false; g.hit = false; g.hold = g.post.slice(); m.unmark('hot' + g.id); m.line('陸遜', `${g.name}將軍，回來！時機未到。`); continue; }
          if (g.x < HOLD_X) V.morale -= 2 * dt; // 將領在界線外，軍心慢慢浮動
          if (SG.gd(g.x, g.y, CAMPS[0][0], CAMPS[0][1]) < 600 && !g.hit) { g.hit = true; V.reached = true; V.morale -= 30; m.line('陸遜', `${g.name}將軍中了埋伏！`); }
        }
        if (me.x < HOLD_X) V.morale -= 10 * dt;
        V.moraleMin = Math.min(V.moraleMin, V.morale);
        m.get('morale').text = `軍心：${Math.max(0, Math.round(V.morale))}%`;
        if (V.morale <= 0) { m.lose('諸將不服，軍心大亂'); return false; }
        return left <= 0;
      },
    },
    { // 2. 各持一把茅：火燒連營
      enter(m, w) {
        const V = m.vars;
        m.done('wait'); m.unmark('line');
        for (const g of V.gens) { g.hot = false; m.unmark('hot' + g.id); }
        m.card('乃敕各持一把茅，以火攻拔之。', '《陸遜傳》');
        m.after(2, () => m.line('陸遜', '蜀軍兵疲意沮，移營入林。就是現在——每人持一把茅，火燒連營！'));
        m.wind = [-1, 0.05];
        V.order = w.t; V.lit = CAMPS.map(() => false);
        CAMPS.forEach(([x, y], i) => m.mark('c' + i, x, y, '蜀營', true));
        m.obj('burn', '火燒連營', CAMPS.length);
        // 三位將領各去點一座
        V.gens.forEach((g, i) => { g.hold = null; g.task = i; });
        for (const u of V.men) { u.home = null; m.join(u, w.player); }
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        CAMPS.forEach(([x, y], i) => {
          if (!V.lit[i] && m.burning(x, y, 260)) { V.lit[i] = true; m.unmark('c' + i); }
          if (!V.lit[i]) m.chanAt(me, 'c' + i, x, y, 260, 1.5, '點火', () => { for (const d of [[-140, 0], [-220, 70], [-220, -70]]) m.fire(x + d[0], y + d[1], { dps: 70 }); }, { hurt: false }); // 火點在營的下風處（西邊）
        });
        // 將領：各自去點一座營（第 1、3、5 座）
        V.gens.forEach((g, i) => {
          if (!g.alive) return;
          const k = [0, 2, 4][i], [x, y] = CAMPS[k];
          if (V.lit[k]) { g.hold = null; return; }
          g.hold = [x + 60, y + 80];
          if (SG.gd(g.x, g.y, x, y) < 220 && !g.chan) m.chan(g, 2, '點火', () => m.fire(x - 140, y, { dps: 70 }), { hurt: false });
        });
        const n = V.lit.filter(Boolean).length;
        m.prog('burn', n);
        return n >= CAMPS.length;
      },
    },
    { // 3. 備因夜遁
      enter(m, w) {
        const V = m.vars;
        V.burnT = w.t - V.order;
        m.done('burn');
        m.card('一爾勢成，通率諸軍同時俱攻，……破其四十餘營。', '《陸遜傳》');
        V.lb.home = [100, 2000]; V.lb.ms = 260;
        rout(m, w, V.shu.concat(V.taunt), [100, 2000]);
        m.after(6, () => m.card('備因夜遁，……僅得入白帝城。', '《陸遜傳》'));
        m.after(12, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('陸遜陣亡'); return; }
    if (V.gens) for (const g of V.gens) allyTick(w, g, null, g.hot ? 200 : 380);
  },
};
